// vim: tabstop=8 softtabstop=0 noexpandtab shiftwidth=8 nosmarttab

export const ENCLAVE_BASE_URL = 'https://enclave.dsbunny.uk';
export const ENABLE_ENCLAVE = true;

export const RMM_BASE_URL = 'https://rmm.dsbunny.uk';
export const RMM_SCOPE = 'openid offline_access api:read api:write';
export const RMM_AUDIENCE = 'https://melanie.dsbunny.com';

export const MAX_BACKOFF_TIMEOUT = 18 * 1000;
export const MIN_BACKOFF_TIMEOUT = 3 * 1000;

// When refreshing tokens, if the access token is set to expire within this time
// frame, it will be refreshed.
export const TOKEN_EXPIRATION_LEEWAY = 60 * 1000;
